import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Card } from "primereact/card";

import { ForgotPasswordAction } from "../../../../store/auth-store/auth-actions";
import { isValidEmail } from "../../../../utils/ValidateUserInfo";
import ABAColor from "../../../../Assets/Img/ABAColor.png";
import "./ForgotPassword.css";

let restartPage = false;



const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const notification = useSelector((state) => state.ui.notification);
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(true);

  const header = (
    <img alt="Card" className="forgotPasswordImage" src={ABAColor} />
  );

  useEffect(() => {
    if (notification && notification.status === "success" && restartPage) {
      window.location.href = "/login";
    }
  }, [navigate, notification]);

  const getFormErrorMessage = (id) => {
    return !isValid ? (
      <Message severity="warn" text="Debe digitar un email" style={{}} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (email === "" || !isValidEmail(email)) {
      setIsValid(false);
    } else {
      dispatch(ForgotPasswordAction(email));
      restartPage = true;
    }
  };

  return (
    <>
      <div className="card flex justify-content-center forgotPasswordBody">
        <div className="formgrid grid ">
          <div className="field col-12 md:col-12">
            <Card className="forgotPasswordCard">
              <div className="field col-12 md:col-2"></div>
              <div className="field col-12 md:col-5">{header}</div>
              <div className="field col-12 md:col-3"></div>
              <div className="field col-12 md:col-12 forgotPasswordTitle">
                <div className="forgotPasswordTitleText">
                  Recuperar contraseña
                </div>
              </div>
              <form onSubmit={onSubmitHandler}>
                <div className="formgrid grid">
                  <div className="field col-12 md:col-12">
                    <InputText
                      className="forgotPasswordEmailTextBox"
                      id="email"
                      value={email}
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div>{getFormErrorMessage("email")}</div>
                  </div>
                  <div className="field col-12 md:col-6">
                    <Button
                      label="Atrás"
                      className="forgotPasswordButtonBack"
                      onClick={() => {
                        navigate(`/login`);
                      }}
                    />
                  </div>
                  <div className="field col-12 md:col-6 ">
                    <Button
                      label="Solicitar"
                      className="forgotPasswordButton"
                      icon={
                        notification && notification.status === "pending"
                          ? "pi pi-spin pi-spinner"
                          : ""
                      }
                      disabled={
                        notification && notification.status === "pending"
                      }
                    />
                  </div>
                </div>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
